// extracted by mini-css-extract-plugin
export default {"error":"cwSLFz","error-content":"C73Vv1","error-content__text":"jBl3o3"};